// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 992px) {
  .layout-dashboard .ant-layout-footer {
    margin: 0;
  }
  .layout-dashboard .ant-layout-sider.sider-primary {
    margin: 20px 0 0 20px;
    padding: 13px 20px;
  }
  .layout-dashboard .ant-layout {
    width: auto;
    flex-shrink: 1;
    margin-left: 0px;
    transform: translate(0, 0);
  }
  .layout-dashboard .header-control .sidebar-toggler {
    display: none;
  }
}
@media (min-width: 768px) {
  .layout-dashboard .ant-layout-header {
    margin: 0px;
    padding: 20px 30px;
  }
  .layout-dashboard .header-control {
    margin-top: 0;
  }
  .layout-dashboard .header-control .header-search {
    margin: 0 7px;
  }
  .layout-dashboard .header-control .btn-sign-in span {
    display: inline;
  }
  .profile-nav-bg {
    margin-top: -87.8px;
  }
  .card-profile-head {
    margin: -53px 24px 24px;
  }
}

@media (min-width: 992px) {
  .card-billing-info.ant-card .ant-card-body {
    display: flex;
  }
  div#root {
    height: 100%;
  }
  .layout-dashboard-rtl {
    overflow: auto;
  }
  .layout-dashboard-rtl .ant-layout-sider.sider-primary {
    margin: 20px 20px 0 0;
    height: calc(100vh - 20px);
  }
  .layout-dashboard-rtl .ant-layout-sider.sider-primary {
    right: 0;
    left: auto;
  }
  .layout-dashboard-rtl .ant-layout-sider.sider-primary {
    right: 0;
    left: auto;
  }
  .layout-dashboard-rtl .ant-layout {
    margin-right: 270px;
    margin-left: 0;
  }
  .layout-dashboard-rtl .ant-layout-footer {
    margin: 0 20px 20px 0;
  }
}
@media (max-width: 1366.98px) {
  .ant-space.ant-space-horizontal.ant-space-align-baseline
    .ant-space.ant-space-horizontal.ant-space-align-baseline {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .ant-card-head-wrapper .ant-card-extra {
    flex-wrap: wrap;
  }
  span.ant-input-group-wrapper.ant-input-search.ant-input-search-large.ant-input-group-wrapper-lg {
    width: auto;
  }
}
@media (max-width: 1199.98px) {
  .ant-space.ant-space-horizontal.ant-space-align-baseline
    .ant-space.ant-space-horizontal.ant-space-align-baseline {
    flex: 0 0 33.33%;
    max-width: 33.33%;
  }
}
@media (max-width: 991px) {
  .signin-bg {
    display: none !important;
  }
}
@media (max-width: 767.98px) {
  .home-cards {
    margin-bottom: 15px;
  }
  .ant-space.ant-space-horizontal.ant-space-align-baseline
    .ant-space.ant-space-horizontal.ant-space-align-baseline {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .layout-dashboard.layout-dashboard-rtl .header-control {
    justify-content: flex-end;
  }
  .ant-card-head-wrapper {
    flex-direction: column !important;
  }
  .ant-card-head-wrapper .ant-card-extra {
    padding-top: 0 !important;
    flex-wrap: wrap;
    justify-content: end;
    align-items: start;
  }
  .ant-card-head-wrapper .ant-card-head-title {
    padding-bottom: 0 !important;
    width: 100%;
  }

  /* 01/06/2023 */
  .layout-dashboard .header-control {
    margin-top: 0;
  }
  .layout-dashboard .header-control {
    margin-top: 0;
  }
  .ant-row {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .ant-col {
    padding: 0 !important;
  }
  .ant-space.ant-space-horizontal.ant-space-align-baseline .ant-col {
    padding: 0 5px !important;
  }
  .tablespace .ant-card-head-title {
    width: 100%;
    font-size: 16px;
  }
  .view-main-list {
    padding-right: 0;
    border-right: 0;
    margin-bottom: 15px;
  }
  .layout-dashboard .header-control svg {
    margin-right: 0 !important;
  }
  .ant-btn.ant-btn-link.sidebar-toggler {
    margin-right: 0 !important;
    padding-right: 0 !important;
  }
  .ant-card-body {
    padding: 12px !important;
  }
  .ant-modal {
    top: 50px !important;
  }
  .card-profile-head .ant-card-head {
    padding: 0 10px !important;
  }
  .card-profile-head .ant-card-head-wrapper .ant-avatar-group .avatar-info h4 {
    font-size: 14px;
  }
  .card-profile-head .ant-card-head-wrapper .ant-avatar-group .avatar-info p {
    font-size: 12px;
  }
}
@media (max-width: 575.98px) {
  .profile-nav-inner {
    flex-wrap: wrap;
  }
  .ant-picker {
    padding: 8px 4px !important;
  }
  .view-inner-cls h6 {
    font-size: 11px;
  }
  .view-inner-cls h5 {
    font-size: 12px;
  }
  .signin-box h5 {
    font-size: 14px !important;
    margin-bottom: 10px !important;
  }
  .signin-box h1 {
    font-size: 16px !important;
  }
  .ant-btn {
    padding: 5px 10px;
    font-size: 12px;
  }
  th,
  td {
    padding: 5px 8px !important;
  }
}
@media (max-width: 480px) {
  .ant-space.ant-space-horizontal.ant-space-align-baseline
    .ant-space.ant-space-horizontal.ant-space-align-baseline {
    flex: 0 0 100%;
    max-width: 100%;
  }
  span.ant-input-group-wrapper.ant-input-search.ant-input-search-large.ant-input-group-wrapper-lg {
    width: 100% !important;
  }
  .ant-input-wrapper.ant-input-group {
    max-width: 100%;
  }
  .ant-card-extra .ant-picker.ant-picker-range {
    width: 100%;
}
.ant-card-extra .ant-select-selector {
  width: 100% !important;
}

  .ant-card-extra .ant-select.ant-select-single.ant-select-show-arrow {
  width: 100%;
}

}

/* SYNCED ARTICLE EDITOR UI RESPONSIVE START */

  .linkedin-article-author-row {
    padding: 0;
    margin-bottom: 16px;
  }

  .linkedin-article-toolbar-shell {
    grid-template-columns: 1fr;
    justify-items: start;
    gap: 12px;
    min-height: auto;
    padding: 12px;
  }

  .linkedin-article-toolbar-center {
    justify-self: center;
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
    border-radius: 24px;
    padding: 8px 10px;
  }

  .linkedin-article-toolbar-group + .linkedin-article-toolbar-group {
    border-left: 0;
    padding-left: 0;
  }

  .normal-editor-shell-article .linkedin-emoji-picker.custom-emoji-modal {
    left: 0;
    width: 320px !important;
    min-width: 320px;
    max-width: calc(100vw - 28px);
    transform: none;
  }

  .normal-editor-shell-article .linkedin-emoji-picker .linkedin-emoji-tabs {
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  }

  .normal-editor-shell-article .linkedin-emoji-picker .linkedin-emoji-grid {
    grid-template-columns: repeat(7, 36px) !important;
  }

  .linkedin-article-divider-delete {
    right: 0;
  }

  .linkedin-article-toolbar-end,
  .linkedin-article-toolbar-spacer {
    display: none;
  }

  .linkedin-article-style-select {
    min-width: 118px;
  }

  .linkedin-article-cover-stage,
  .linkedin-article-cover-placeholder,
  .linkedin-article-cover-media,
  .normal-editor-shell-article .rdw-editor-main {
    min-height: 280px;
  }

  .linkedin-article-cover-trigger {
    min-width: 210px;
    bottom: 18px;
  }

  .normal-editor-shell-article .rdw-editor-main {
    padding: 0 10px 22px;
    font-size: 16px;
  }

  .linkedin-article-title-shell {
    padding: 0 10px;
  }

  .linkedin-article-title-input {
    min-height: 48px;
    font-size: 32px;
    line-height: 1.18;
  }

/* SYNCED ARTICLE EDITOR UI RESPONSIVE END */
`, "",{"version":3,"sources":["webpack://./src/assets/styles/responsive.css"],"names":[],"mappings":"AAAA;EACE;IACE,SAAS;EACX;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;IACrB,0BAA0B;EAC5B;EACA;IACE,QAAQ;IACR,UAAU;EACZ;EACA;IACE,QAAQ;IACR,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE;;IAEE,aAAa;IACb,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;;IAEE,aAAa;IACb,cAAc;EAChB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,yBAAyB;IACzB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;EACpB;EACA;IACE,4BAA4B;IAC5B,WAAW;EACb;;EAEA,eAAe;EACf;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;;IAEE,2BAA2B;EAC7B;AACF;AACA;EACE;;IAEE,cAAc;IACd,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;AACf;AACA;EACE,sBAAsB;AACxB;;EAEE;EACA,WAAW;AACb;;AAEA;;AAEA,8CAA8C;;EAE5C;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,SAAS;IACT,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,OAAO;IACP,uBAAuB;IACvB,gBAAgB;IAChB,6BAA6B;IAC7B,eAAe;EACjB;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,iDAAiD;EACnD;;EAEA;IACE,QAAQ;EACV;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;;IAIE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;;AAEF,4CAA4C","sourcesContent":["@media (min-width: 992px) {\n  .layout-dashboard .ant-layout-footer {\n    margin: 0;\n  }\n  .layout-dashboard .ant-layout-sider.sider-primary {\n    margin: 20px 0 0 20px;\n    padding: 13px 20px;\n  }\n  .layout-dashboard .ant-layout {\n    width: auto;\n    flex-shrink: 1;\n    margin-left: 0px;\n    transform: translate(0, 0);\n  }\n  .layout-dashboard .header-control .sidebar-toggler {\n    display: none;\n  }\n}\n@media (min-width: 768px) {\n  .layout-dashboard .ant-layout-header {\n    margin: 0px;\n    padding: 20px 30px;\n  }\n  .layout-dashboard .header-control {\n    margin-top: 0;\n  }\n  .layout-dashboard .header-control .header-search {\n    margin: 0 7px;\n  }\n  .layout-dashboard .header-control .btn-sign-in span {\n    display: inline;\n  }\n  .profile-nav-bg {\n    margin-top: -87.8px;\n  }\n  .card-profile-head {\n    margin: -53px 24px 24px;\n  }\n}\n\n@media (min-width: 992px) {\n  .card-billing-info.ant-card .ant-card-body {\n    display: flex;\n  }\n  div#root {\n    height: 100%;\n  }\n  .layout-dashboard-rtl {\n    overflow: auto;\n  }\n  .layout-dashboard-rtl .ant-layout-sider.sider-primary {\n    margin: 20px 20px 0 0;\n    height: calc(100vh - 20px);\n  }\n  .layout-dashboard-rtl .ant-layout-sider.sider-primary {\n    right: 0;\n    left: auto;\n  }\n  .layout-dashboard-rtl .ant-layout-sider.sider-primary {\n    right: 0;\n    left: auto;\n  }\n  .layout-dashboard-rtl .ant-layout {\n    margin-right: 270px;\n    margin-left: 0;\n  }\n  .layout-dashboard-rtl .ant-layout-footer {\n    margin: 0 20px 20px 0;\n  }\n}\n@media (max-width: 1366.98px) {\n  .ant-space.ant-space-horizontal.ant-space-align-baseline\n    .ant-space.ant-space-horizontal.ant-space-align-baseline {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .ant-card-head-wrapper .ant-card-extra {\n    flex-wrap: wrap;\n  }\n  span.ant-input-group-wrapper.ant-input-search.ant-input-search-large.ant-input-group-wrapper-lg {\n    width: auto;\n  }\n}\n@media (max-width: 1199.98px) {\n  .ant-space.ant-space-horizontal.ant-space-align-baseline\n    .ant-space.ant-space-horizontal.ant-space-align-baseline {\n    flex: 0 0 33.33%;\n    max-width: 33.33%;\n  }\n}\n@media (max-width: 991px) {\n  .signin-bg {\n    display: none !important;\n  }\n}\n@media (max-width: 767.98px) {\n  .home-cards {\n    margin-bottom: 15px;\n  }\n  .ant-space.ant-space-horizontal.ant-space-align-baseline\n    .ant-space.ant-space-horizontal.ant-space-align-baseline {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .layout-dashboard.layout-dashboard-rtl .header-control {\n    justify-content: flex-end;\n  }\n  .ant-card-head-wrapper {\n    flex-direction: column !important;\n  }\n  .ant-card-head-wrapper .ant-card-extra {\n    padding-top: 0 !important;\n    flex-wrap: wrap;\n    justify-content: end;\n    align-items: start;\n  }\n  .ant-card-head-wrapper .ant-card-head-title {\n    padding-bottom: 0 !important;\n    width: 100%;\n  }\n\n  /* 01/06/2023 */\n  .layout-dashboard .header-control {\n    margin-top: 0;\n  }\n  .layout-dashboard .header-control {\n    margin-top: 0;\n  }\n  .ant-row {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .ant-col {\n    padding: 0 !important;\n  }\n  .ant-space.ant-space-horizontal.ant-space-align-baseline .ant-col {\n    padding: 0 5px !important;\n  }\n  .tablespace .ant-card-head-title {\n    width: 100%;\n    font-size: 16px;\n  }\n  .view-main-list {\n    padding-right: 0;\n    border-right: 0;\n    margin-bottom: 15px;\n  }\n  .layout-dashboard .header-control svg {\n    margin-right: 0 !important;\n  }\n  .ant-btn.ant-btn-link.sidebar-toggler {\n    margin-right: 0 !important;\n    padding-right: 0 !important;\n  }\n  .ant-card-body {\n    padding: 12px !important;\n  }\n  .ant-modal {\n    top: 50px !important;\n  }\n  .card-profile-head .ant-card-head {\n    padding: 0 10px !important;\n  }\n  .card-profile-head .ant-card-head-wrapper .ant-avatar-group .avatar-info h4 {\n    font-size: 14px;\n  }\n  .card-profile-head .ant-card-head-wrapper .ant-avatar-group .avatar-info p {\n    font-size: 12px;\n  }\n}\n@media (max-width: 575.98px) {\n  .profile-nav-inner {\n    flex-wrap: wrap;\n  }\n  .ant-picker {\n    padding: 8px 4px !important;\n  }\n  .view-inner-cls h6 {\n    font-size: 11px;\n  }\n  .view-inner-cls h5 {\n    font-size: 12px;\n  }\n  .signin-box h5 {\n    font-size: 14px !important;\n    margin-bottom: 10px !important;\n  }\n  .signin-box h1 {\n    font-size: 16px !important;\n  }\n  .ant-btn {\n    padding: 5px 10px;\n    font-size: 12px;\n  }\n  th,\n  td {\n    padding: 5px 8px !important;\n  }\n}\n@media (max-width: 480px) {\n  .ant-space.ant-space-horizontal.ant-space-align-baseline\n    .ant-space.ant-space-horizontal.ant-space-align-baseline {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  span.ant-input-group-wrapper.ant-input-search.ant-input-search-large.ant-input-group-wrapper-lg {\n    width: 100% !important;\n  }\n  .ant-input-wrapper.ant-input-group {\n    max-width: 100%;\n  }\n  .ant-card-extra .ant-picker.ant-picker-range {\n    width: 100%;\n}\n.ant-card-extra .ant-select-selector {\n  width: 100% !important;\n}\n\n  .ant-card-extra .ant-select.ant-select-single.ant-select-show-arrow {\n  width: 100%;\n}\n\n}\n\n/* SYNCED ARTICLE EDITOR UI RESPONSIVE START */\n\n  .linkedin-article-author-row {\n    padding: 0;\n    margin-bottom: 16px;\n  }\n\n  .linkedin-article-toolbar-shell {\n    grid-template-columns: 1fr;\n    justify-items: start;\n    gap: 12px;\n    min-height: auto;\n    padding: 12px;\n  }\n\n  .linkedin-article-toolbar-center {\n    justify-self: center;\n    width: 100%;\n    flex-wrap: wrap;\n    justify-content: center;\n    border-radius: 24px;\n    padding: 8px 10px;\n  }\n\n  .linkedin-article-toolbar-group + .linkedin-article-toolbar-group {\n    border-left: 0;\n    padding-left: 0;\n  }\n\n  .normal-editor-shell-article .linkedin-emoji-picker.custom-emoji-modal {\n    left: 0;\n    width: 320px !important;\n    min-width: 320px;\n    max-width: calc(100vw - 28px);\n    transform: none;\n  }\n\n  .normal-editor-shell-article .linkedin-emoji-picker .linkedin-emoji-tabs {\n    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;\n  }\n\n  .normal-editor-shell-article .linkedin-emoji-picker .linkedin-emoji-grid {\n    grid-template-columns: repeat(7, 36px) !important;\n  }\n\n  .linkedin-article-divider-delete {\n    right: 0;\n  }\n\n  .linkedin-article-toolbar-end,\n  .linkedin-article-toolbar-spacer {\n    display: none;\n  }\n\n  .linkedin-article-style-select {\n    min-width: 118px;\n  }\n\n  .linkedin-article-cover-stage,\n  .linkedin-article-cover-placeholder,\n  .linkedin-article-cover-media,\n  .normal-editor-shell-article .rdw-editor-main {\n    min-height: 280px;\n  }\n\n  .linkedin-article-cover-trigger {\n    min-width: 210px;\n    bottom: 18px;\n  }\n\n  .normal-editor-shell-article .rdw-editor-main {\n    padding: 0 10px 22px;\n    font-size: 16px;\n  }\n\n  .linkedin-article-title-shell {\n    padding: 0 10px;\n  }\n\n  .linkedin-article-title-input {\n    min-height: 48px;\n    font-size: 32px;\n    line-height: 1.18;\n  }\n\n/* SYNCED ARTICLE EDITOR UI RESPONSIVE END */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
